<template>
  <section class="home" id="home">
    <div class="content">
      <!-- <span class="hi"> hello world! </span> -->
      <h3><span> Kemal Beler</span></h3>
      <p class="info">front-end developer</p>
      <!-- <p class="text" id="text">
        html, css, javascript, vue, react, firebase, supabase, nodejs, mongodb,
        canvas, threejs, p5js,...
      </p> -->
      <p class="text" id="text">.</p>
      <a href="#about" class="btn">about me</a>
    </div>

    <div class="image">
      <!-- <img src="@/assets/images/home-img.png" alt="" /> -->
      <img src="@/assets/images/Developer_Isometric.png" alt="" />
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    const textEl = document.getElementById("text");
    // const speedEl = document.getElementById('speed')
    const text =
      "I know a little bit html, css, js, react, react-native, vue, nextjs, nuxtjs, mongo, quasar, sass, bootstrap, tailwind, nodejs, d3js, p5js, . . . . . . . . ";

    let idx = 1;
    // let speed = 100 / speedEl.value

    writeText();

    function writeText() {
      //text i elemanlarına ayıralım
      textEl.innerText = text.slice(0, idx);
      //index i arttıralım
      idx++;
      //text in so elemanını tespit
      if (idx > text.length) {
        idx = 1;
      }
      //hızı ayarlayalım
      setTimeout(writeText, 100);
    }

    // speedEl.addEventListener("input", (e) => (speed = 300 / e.target.value));
  },
};
</script>
